import KeyFactsDropDownContainer from './KeyFactsDropDownContainer';

export default KeyFactsDropDownContainer;
